module.exports = __webpack_public_path__ + "img/black.bd032978.png";